import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';
import { ProgressBarColorDirective } from 'src/app/core/directives/progress-bar-color.directive';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';

@Component({
  selector: 'app-default',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    MatIconModule,
    MyButtonComponent,
    ProgressBarColorDirective
  ],
  templateUrl: './default.component.html',
  styleUrl: './default.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultComponent {
  snackBarRef = inject(MatSnackBarRef);
  duration: number = 0;
  timer = signal(0);
  interval: number = 1;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {
    if (this.data.duration !== 0) {
      this.timer.set(this.data.duration/(1000));
      setInterval(() => {
        this.timer.update((value) => value - this.interval);
      }, 1000)
    }
  }
}
